/** When your routing table is too long, you can split it into small modules**/

import Layout from '@/views/layout/layout'

const agentManageRouter = {
  path: '/manageChannelManage',
  component: Layout,
  hidden: false,
  redirect: 'noredirect',
  name: 'ManageChannelManage',
  meta: {
    title: '通道管理',
    icon: 'channel',
    roles: ['admin']
  },
  children: [
    {
      path: 'channelList',
      component: resolve => require(['@/views/manage/channelManage/channelList'], resolve),
      name: 'ChannelList',
      meta: { title: '代收通道列表', noCache: false }
    },
    {
      path: 'remitChannelList',
      component: resolve => require(['@/views/manage/channelManage/remitChannelList'], resolve),
      name: 'RemitChannelList',
      meta: { title: '代付通道列表', noCache: false }
    },
    {
      path: 'channelType',
      component: resolve => require(['@/views/manage/channelManage/channelType'], resolve),
      name: 'ChannelType',
      meta: { title: '通道类型', noCache: false }
    },
    {
      path: 'channelWithdraw',
      component: resolve => require(['@/views/manage/channelManage/channelWithdraw'], resolve),
      name: 'ChannelWithdraw',
      meta: { title: '通道提现', noCache: false }
    },
    {
      path: 'channelPlatformList',
      component: resolve => require(['@/views/manage/channelManage/channelPlatformList'], resolve),
      name: 'channelPlatformList',
      meta: { title: '信用额度配置', noCache: false }
    },
    { path: 'usInstructConfig',
      component: resolve => require(['@/views/manage/channelManage/usInstructConfig'], resolve),
      name: 'UsInstructConfig',
      meta: { title: '上游机器人配置', noCache: false }
    },
    {
      path: 'channelGroupList',
      component: resolve => require(['@/views/manage/channelManage/channelGroupList'], resolve),
      name: 'ChannelGroupList',
      meta: { title: '通道组配置', noCache: false }
    },
    // {
    //   path: 'channelAccountList',
    //   component: resolve => require(['@/views/manage/channelManage/channelAccountList'], resolve),
    //   name: 'ChannelAccountList',
    //   meta: { title: '通道账号列表', noCache: false }
    // },
    // {
    //   path: 'newAccount/:id',
    //   component: resolve => require(['@/views/manage/channelManage/newAccount'], resolve),
    //   name: 'NewAccount',
    //   meta: { title: '新建通道账号', noCache: false, noKeepAlive: true },
    //   hidden: true
    // },
    // {
    //   path: 'accountDetail/:id',
    //   component: resolve => require(['@/views/manage/channelManage/accountDetail'], resolve),
    //   name: 'AccountDetail',
    //   meta: { title: '通道账号详情', noCache: false },
    //   hidden: true
    // },
    // {
    //   path: 'channelTradeRoute-57',
    //   component: resolve => require(['@/views/manage/channelManage/channelTradeRoute'], resolve),
    //   name: 'ChannelTradeRoute',
    //   meta: { title: '交易路由', noCache: false }
    // },
    // {
    //   path: 'channelPayAnotherRoute-58',
    //   component: resolve => require(['@/views/manage/channelManage/channelPayAnotherRoute'], resolve),
    //   name: 'ChannelPayAnotherRoute',
    //   meta: { title: '提现路由', noCache: false }
    // },
    // {
    //   path: 'channelAccountSearch',
    //   component: resolve => require(['@/views/manage/channelManage/channelAccountSearch'], resolve),
    //   name: 'ChannelAccountSearch',
    //   meta: { title: '通道余额查询', noCache: false }
    // },
    // {
    //   path: 'cBankVerificationManagement',
    //   component: resolve => require(['@/views/manage/channelManage/cBankVerificationManagement'], resolve),
    //   name: 'CBankVerificationManagement',
    //   meta: { title: '银行卡验证管理', noCache: false }
    // },
    // {
    //   path: 'cBankDetail/:id',
    //   component: resolve => require(['@/views/manage/channelManage/cBankDetail'], resolve),
    //   name: 'CBankDetail',
    //   meta: { title: '银行卡验证管理详情', noCache: false },
    //   hidden: true
    // },
    // {
    //   path: 'newcBank/:id',
    //   component: resolve => require(['@/views/manage/channelManage/newcBank'], resolve),
    //   name: 'NewcBank',
    //   meta: { title: '银行卡验证管理修改', noCache: false, noKeepAlive: true },
    //   hidden: true
    // }
  ]
}

export default agentManageRouter



// WEBPACK FOOTER //
// ./src/router/manage/channelManage.js